export default __webpack_public_path__ + "static/media/radio-unselected-tick-light.ed52c06a.svg";